import { motion } from "framer-motion";
import { StarIcon } from "hugeicons-react";

interface SectionBadgeProps {
  text: string;
  icon?: any;
  variant?: 'glass' | 'ghost';
  showDot?: boolean;
}

export default function SectionBadge({ 
  text, 
  icon: Icon = StarIcon,
  variant = 'glass',
  showDot = false
}: SectionBadgeProps) {
  const styles = {
    glass: "bg-[#050505]/80 border-white/[0.08] shadow-[0_10px_40px_-10px_rgba(0,0,0,0.5)]",
    ghost: "bg-white/5 border-white/10"
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      className={`inline-flex items-center gap-3 px-4 py-2 rounded-full backdrop-blur-xl border mb-8 group transition-all duration-500 relative overflow-hidden ${styles[variant]}`}
    >
      {variant === 'glass' && (
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      )}
      
      {showDot ? (
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
        </span>
      ) : (
        <Icon size={14} className="text-primary animate-pulse group-hover:scale-110 transition-transform" />
      )}

      <span className={`text-[11px] font-bold uppercase tracking-wider ${variant === 'ghost' ? 'text-white' : 'text-primary/90'}`}>
        {text}
      </span>
    </motion.div>
  );
}
